import RequestForm from "@/components/sections/RequestForm";
import { useSEO } from "@/lib/hooks";

export default function RequestPage() {
  useSEO({
    title: "Demande de dépannage — Depann7",
    description: "Faites votre demande de dépannage en ligne. Nous vous rappelons immédiatement pour intervenir rapidement en Île-de-France.",
  });
  return (
    <div className="bg-white">
      <div className="bg-ink-900 text-white py-14">
        <div className="max-w-6xl mx-auto px-4 lg:px-6">
          <h1 className="text-3xl lg:text-4xl font-extrabold">Demande de dépannage</h1>
          <p className="text-ink-300 mt-2 max-w-2xl">Remplissez ce formulaire, joignez des photos et indiquez votre position GPS. Nous vous rappelons dans les plus brefs délais.</p>
        </div>
      </div>
      <div className="max-w-3xl mx-auto px-4 lg:px-6 py-12">
        <div className="bg-white border border-surface-200 rounded-2xl shadow-card overflow-hidden"><RequestForm /></div>
      </div>
    </div>
  );
}
